import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    baseUrl: 'https://py.loginsa.com/api_oms/api/tracking/', //<----- PRODUCCIÓN
    baseUrlCourier: "https://ws.loginsa.com/ApiPortalInfor/api/", // <- PRODUCCION-IMAGE
    // baseUrlCourier: "https://localhost:44373/api/", //<-- DEPURACION-IMAGE
    // baseUrlCourier: "https://tzl.loginsa.com/ApiPortalInfor/api/", //<- TEST-IMAGE
    // baseUrl: 'http://10.15.3.174/api_oms/api/tracking/', //<----- TESTING
    token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6IjAzMzkyYzJkLWYyMmYtNDQwNy04YWQ3LTQ3MmIzMjQ0OGFhYyIsImV4cCI6MTc4MDUyMzM1MSwiaWF0IjoxNjk0MTIzMzUxfQ.jRxwKKePUZHFehIBaPnfxV0rLe11NhNzzGJgSi1Y69s',
    idTrack: null,
    ordenClienteFinal: null,  
    storerKey: null,
    loading: false,
    tokenCourier: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6ImpidXN0b3MiLCJuYmYiOjE3MjA1NTc2ODcsImV4cCI6MTcyMDU2NDg4NywiaWF0IjoxNzIwNTU3Njg3LCJpc3MiOiJodHRwOi8vbG9jYWxob3N0OjgwODIiLCJhdWQiOiJodHRwOi8vbG9jYWxob3N0OjgwODIifQ.SLcbKJlIudRDVJ8JKAdJYE2frMV6yiwOABfgPckdSh8',
    theme: null,
    hideItem: false,
    couriers: [],
    mobile: false,
    imagen: [
      //original
      {
        id_cliente: "L00357",
        logo2: require("@/assets/empresas/logo-Santillana.png"),
        nombre: "Santillana",
      },
      {
        id_cliente: "I00074",
        logo2: require("@/assets/empresas/undurraga.png"),
        nombre: "undurraga",
      },
      {
        id_cliente: "I00088",
        logo2: require("@/assets/empresas/just.png"),
        nombre: "just",
      },
      {
        id_cliente: "I00098",
        logo2: require("@/assets/empresas/AmaTime.png"),
        nombre: "AmaTime",
      },
      {
        id_cliente: "I00119",
        logo2: require("@/assets/empresas/paramo.png"),
        nombre: "Comercializadora Paramo spa",
      },
      {
        id_cliente: "I00120",
        logo2: require("@/assets/empresas/OSOJIROBOTICSCORPORATIONCHILESPA.png"),
        nombre: "OSOJI CHILE SPA",
      },
      {
        id_cliente: "I00122",
        logo2: require("@/assets/empresas/dnjoy.png"),
        nombre: "D-NJOY CHILE SPA",
      },
      {
        id_cliente: "I00123",
        logo2: require("@/assets/empresas/latamhair.png"),
        nombre: "LATAMHAIR SPA",
      },
      {
        id_cliente: "I00127",
        logo2: require("@/assets/empresas/prosud.jpg"),
        nombre: "Prosud S.A.",
      },
      {
        id_cliente: "I00128",
        logo2: require("@/assets/empresas/gaconfecciones.png"),
        nombre: "GA CONFECCIONES SPA",
      },
      {
        id_cliente: "I00143",
        logo2: require("@/assets/empresas/comercialchi.png"),
        nombre: "COMERCIAL CHI SPA",
      },
      {
        id_cliente: "I00153",
        logo2: require("@/assets/empresas/rebel.png"),
        nombre: "REBEL",
      },
      {
        id_cliente: "I00154",
        logo2: require("@/assets/empresas/soymomo.png"),
        nombre: "SOY MOMO",
      },
      {
        id_cliente: "I00163",
        logo2: require("@/assets/empresas/tupperware.png"),
        nombre: "TUPPERWARE",
      },
      {
        id_cliente: "I00069",
        logo2: require("@/assets/empresas/bravium.jpg"),
        nombre: "BRAVIUM",
      },
      {
        id_cliente: "I00157",
        logo2: require("@/assets/empresas/evolve.png"),
        nombre: "EVOLVE",
      },
      {
        id_cliente: "NATURA",
        logo2: require("@/assets/empresas/natura.png"),
        nombre: "NATURA",
      },
      {
        id_cliente: "I00174",
        logo2: require("@/assets/empresas/reebok.jpg"),
        nombre: "Reebok",
      },
      //hasta aca
      {
        id_cliente: "I00187",
        logo2: require("@/assets/empresas/GKHAIR.png"),
        nombre: "GKHAIR",
      },
      {
        id_cliente: "I00151",
        logo2: require("@/assets/empresas/PISAFARMACEUTICACHILESA.jpg"),
        nombre: "PISA FARMACEUTICA CHILE S.A.",
      },
      {
        id_cliente: "L00223",
        logo2: require("@/assets/empresas/gasei.png"),
        nombre: "GASEI",
      },
      {
        id_cliente: "I00184",
        logo2: require("@/assets/empresas/ariex.png"),
        nombre: "ARIEX",
      },
      {
        id_cliente: "I00178",
        logo2: require("@/assets/empresas/atlantic.jpg"),
        nombre: "ATLANTIC",
      },


      {
        id_cliente: "I00177",
        logo2: require("@/assets/empresas/tendril.png"),
        nombre: "TENDRIL SPA",
      },

      //Tewner 1
      {
        id_cliente: "I00211",
        logo2: require("@/assets/empresas/Tewner.png"),
        nombre: "Irobot",
      },
      //Tewner 2
      {
        id_cliente: "I00211",
        logo2: require("@/assets/empresas/Aftec.png"),
        nombre: "Aftec",
      },



      
      // {
      //   id_cliente: "I00040",
      //   logo2: require("@/assets/empresas/nikken.png"),
      //   nombre: "nikken",
      // },

      // {
      //   id_cliente: 22,
      //   logo2: require("@/assets/empresas/PISAFARMACEUTICACHILESA.jpg"),
      //   nombre: "PISAFARMACEUTICACHILESA",
      // },
      // {
      //   id_cliente: "I00063",
      //   logo2: require("@/assets/empresas/puroyclaro.jpg"),
      //   nombre: "puroyclaro",
      // },
      // {
      //   id_cliente: 24,
      //   logo2: require("@/assets/empresas/ripley.png"),
      //   nombre: "ripley",
      // },
      // {
      //   id_cliente: 25,
      //   logo2: require("@/assets/empresas/steward.jpg"),
      //   nombre: "steward",
      // },
      // {
      //   id_cliente: 26,
      //   logo2: require("@/assets/empresas/toyotomi.png"),
      //   nombre: "toyotomi",
      // },

      // {
      //   id_cliente: "I00083",
      //   logo2: require("@/assets/empresas/liftit.png"),
      //   nombre: "liftit",
      // },
      // {
      //   id_cliente: "I00070",
      //   logo2: require("@/assets/empresas/BELLAPIERRE.png"),
      //   nombre: "BELLAPIERRE",
      // },
    ],
    logo2: null,
    buscador: true,
  selectedCourier: null, 
  },
  getters: {
    mapImagen(state) {
      return state.imagen.map(img => ({
        text: img.nombre.toUpperCase(),
        value: img.id_cliente,
        img: img.logo2,
      }));
    },
    mapCouriers(state) {
      return state.couriers.map(cli => ({
        nombre: cli.nombre,
        id_cliente: cli.id_cliente,
        estado: cli.estado,
        logo: cli.logo,
        logo2: cli.logo2
      }));
    },
    selectedCourier(state) {
      return state.selectedCourier; // Getter para obtener el courier seleccionado
    },
  },
  mutations: {
    setSelectedCourier(state, courier) { // Nueva mutación para establecer el courier seleccionado
      state.selectedCourier = courier;
    },
    setIdTrack(state, payload) {
      state.idTrack = payload;
    },
    setOrdenClienteFinal(state, payload) {
      state.ordenClienteFinal = payload;
    },
    setCouriers(state, couriers) {
      state.couriers = couriers;
    },
    setStorerKey(state, payload) {
      state.storerKey = payload;
    },
    mostrarLoading(state, payload) {
      state.loading.titulo = payload.titulo
      state.loading.estado = true
      state.loading.color = payload.color
    },
    ocultarLoading(state) {
      state.loading.estado = false
    },
    setTheme(state, payload) {
      state.theme = payload;
    },
    setHide(state, payload) {
      state.hideItem = payload;
    },
    setMobile(state, payload) {
      state.mobile = payload;
    },
    setImagen(state, payload) {
      state.imagen = payload;
    },
    setCuenta(state, payload) {
      state.cuenta = payload;
    },
    setUrl(state, payload) {
      state.url = payload;
    },
    setBuscador(state, payload) {
      state.buscador = payload;
    },
  },
  actions: {
    listarCouriers({ state, commit }) {

      const url = `${state.baseUrlCourier}tracking/ListarCourier?token=${state.tokenCourier}`;      
      axios.get(url)
        .then(response => {
          console.log(url)
          console.log("Couriers response:", response.data); // Verifica la respuesta
          commit('setCouriers', response.data);
        })
        .catch(error => {
          console.error('Error al obtener los couriers:', error);
        });
    }
  }
  });
